import MarketDealsTable from '@/creditflowresearch/ui/components/deals/DealListTable/DealsTable/MarketDealsTable';
import { getCorporateMarketColumns } from '@/creditflowresearch/ui/components/deals/DealListTable/columns/CorporateMarketColumns';

const CorporateMarketDealsTable = (props) => (
  <MarketDealsTable
    columns={ getCorporateMarketColumns() }
    { ...props }
  />
);

export default CorporateMarketDealsTable;
